import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/",
    redirect: "/home", // 重定向
    component: () => import("../views/Main"),
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("../views/Home"),
      },
      {
        path: "/record",
        name: "record",
        redirect: "/record/travel",
        component: () => import("../views/Record"),
        children: [
          {
            path: "travel",
            name: "travel",
            component: () => import("../views/Travel"),
          },
          {
            path: "learn",
            name: "learn",
            component: () => import("../views/Learn"),
          },
          {
            path: "detail",
            name: "detail",
            component: () => import("../views/Article"),
          },
        ],
      },
      {
        path: "/about",
        name: "about",
        component: () => import("../views/About"),
      },
      {
        path: "/letter",
        name: "letter",
        component: () => import("../views/Letter"),
      },
    ],
  },
  {
    path: "/manage/article",
    name: "article",
    component: () => import("../views/manage/EditArticle"),
    meta: { isAuth: true },
  },
  {
    path: "/manage",
    redirect: "/manage/articleList",
    meta: { isAuth: true },
    component: () => import("../views/manage/ManageMain"),
    children: [
      {
        path: "screen",
        name: "screen",
        component: () => import("../views/manage/Screen"),
        meta: { isAuth: true },
      },
      {
        path: "roleList",
        name: "roleList",
        component: () => import("../views/manage/RoleList"),
        meta: { isAuth: true },
      },
      {
        path: "userList",
        name: "userList",
        component: () => import("../views/manage/UserList"),
        meta: { isAuth: true },
      },
      {
        path: "articleList",
        name: "articleList",
        component: () => import("../views/manage/ArticleList"),
        meta: { isAuth: true },
      },
      {
        path: "sortList",
        name: "sortList",
        component: () => import("../views/manage/SortList"),
        meta: { isAuth: true },
      },
      {
        path: "commentList",
        name: "commentList",
        component: () => import("../views/manage/CommentList"),
        meta: { isAuth: true },
      },
      {
        path: "letterList",
        name: "letterList",
        component: () => import("../views/manage/LetterList"),
        meta: { isAuth: true },
      },
      {
        path: "resourceList",
        name: "resourceList",
        component: () => import("../views/manage/ResourceList"),
        meta: { isAuth: true },
      },
    ],
  },
];
//消除路由冲突警告
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
  meta: {
    title: "记录生活的懒猫米米",
  },
});

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title || router.options.meta.title; // 使用当前路由的标题或默认标题
  if (to.path.includes("record")) {
    store.commit("changeReadingStatus", true);
  } else {
    store.commit("changeReadingStatus", false);
  }
  if (to.meta.isAuth) {
    // 获取token
    const token = sessionStorage.getItem("token");
    if (!token && to.name !== "login") {
      next({ name: "login" });
    }
    if (token && to.name === "login") {
      next({ name: "/" });
    } else {
      next();
    }
  }
  next();
});
export default router;
